"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withTheme = _interopRequireDefault(require("../withTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizeTypes = {
  small: '14px',
  medium: '16px',
  large: '24px'
};

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      color = _ref.color,
      size = _ref.size,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["icon", "color", "size", "theme"]);

  var styles = {
    root: {
      color: theme[color]['500'],
      size: sizeTypes[size]
    }
  };
  return /*#__PURE__*/_react["default"].createElement("i", _extends({}, props, {
    className: icon,
    style: styles.root
  }));
};

Icon.propTypes = {
  /**
   * Icon color
   */
  color: _propTypes["default"].string,

  /**
   * Icon size
   */
  size: _propTypes["default"].string
};
Icon.defaultProps = {
  color: 'primary',
  size: 'small'
};

var _default = (0, _withTheme["default"])(Icon);

exports["default"] = _default;